export default [
	{
		href: 'bm-accounts/list',
		name: 'List',
		permission: null
	},
	{
		href: 'bm-accounts/categories',
		name: 'Categories',
		permission: null
	}
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/bm-accounts/tabs.js